<template>
  <div>
    <Subheader v-model="search" title="Discrete Sample Stations" search="Discrete Sample Stations">
      <v-btn small color="success" @click="clickAddStation()">
        <v-icon class="mr-1">add</v-icon>
        {{ $t('Button.add_station') }}
      </v-btn>
    </Subheader>
    <v-card>
      <v-card-text>
        To recover a deleted station, please contact EIS with the station's name.
      </v-card-text>
      <v-data-table :headers="headers" :items="discreteSampleStations" :pagination.sync="pagination" :search="search" item-key="name">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.locationType }}</td>
          <td class="text-xs-right">
            <v-btn small dark color="delete" @click="deleteStation = props.item; confirmDialog = true">
              <v-icon class="mr-1">delete_forever</v-icon>
              {{ $t('Button.Delete') }}
            </v-btn>
          </td>
        </template>
        <template slot="no-data">
          <v-progress-linear v-show="progress" indeterminate color="secondary"></v-progress-linear>
          <p v-show="!progress">No data available</p>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" max-width="800px">
      <v-flex xs12>
        <v-toolbar dense color="secondary" dark class="removePadding">
          <v-toolbar-title>{{ $t('AdministrationDiscreteSampleStations.addTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 pa-3>
              <v-text-field label="Station Name" v-model="newStation" />
              <v-select label="Station Category" :items="stationCategories" item-text="Name" item-value="Name" v-model="category" hint="when category is empty, it will be set to 'Unknown'" persistent-hint>
              </v-select>

              <v-checkbox color="info" class="mt-" v-model="autoAssign" label="Auto-assign to a location" persistent-hint hint="Station will be assigned to a new or existing location." />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading.submit" color="success" small @click="clickSave()">
            <v-icon class="mr-1">done</v-icon>
            {{ $t('Button.Save') }}
          </v-btn>
          <v-btn outline color="secondary" small @click="clearForm()">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDialog" max-width="800">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('AdministrationDiscreteSampleStations.confirmTitleMsg', { msg: deleteStation.name }) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="confirmDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>{{ $t('AdministrationDiscreteSampleStations.confirmTextMsg') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.native="agreeDeleteStation()">
            <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.REMOVE_STATION') }}
          </v-btn>
          <v-btn outline color="secondary" @click.native="confirmDialog = false">{{ $t('Button.CANCEL') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  const admin = createNamespacedHelpers('admin')
  const authenticate = createNamespacedHelpers('authenticate')
  const app = createNamespacedHelpers('app')
  const stations = createNamespacedHelpers('stations')
  const dataSources = createNamespacedHelpers('datasource')
  const navigation = createNamespacedHelpers('navigation')
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  export default {
    props: {
      name: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        search: '',
        pagination: {
          rowsPerPage: 5,
        },
        headers: [{
          align: 'left',
          text: 'Station',
          value: 'name',
        },
        {
          align: 'left',
          text: 'Category',
          value: 'locationType',
        },
        {
          align: 'left',
          sortable: false,
        },
        ],
        loading: {
          submit: false,
        },
        progress: false,
        dialog: false,
        confirmDialog: false,
        newStation: '',
        category: '',
        autoAssign: true,
        deleteStation: {},
      }
    },
    mounted() {
      this.progress = true
      var options = {
        data: this.name,
        successCb: () => {
          this.progress = false
        },
      }
      this.getDiscreteSampleStations(options)
    },
    computed: {
      ...admin.mapGetters(['roleList', 'discreteSampleStations']),
      ...stations.mapGetters(['stationCategories', 'grabSampleStations', 'CurrentSideMenuSetting']),
      ...authenticate.mapGetters(['currentUserGroup']),
      ...dataSources.mapGetters(['dataSourceIndex']),
      currentTenant() {
        console.log('rolelist', this.roleList, this.name)
        return this.roleList.find(x => x.RoleName == this.name)
      },
    },
    methods: {
      ...admin.mapActions(['postAddDiscreteStation', 'postDeleteDiscreteStation', 'getDiscreteSampleStations']),
      ...stations.mapActions(['adminAddStation', 'adminDeleteStation']),
      ...app.mapActions(['setSnackbar']),
      ...dataSources.mapActions(['fetchDataSources', 'autoAssignDataSources']),
      ...navigation.mapActions(['fetchSideMenu']),
      ...monitoringFeatures.mapActions(['fetchMonitoringFeaturesUI']),
      clickManageStation(data) {
        this.stationId = data.Id
      },
      clickAddStation() {
        this.dialog = true
      },
      clickSave() {
        if (this.newStation == null || this.newStation.trim() == '') {
          this.setSnackbar({
            icon: 'warning',
            color: 'warning',
            text: this.$t('AdministrationDiscreteSampleStations.saveEmptyFailMsg'),
          })
        } else {
          let checkName = this.discreteSampleStations.find(e => e.Name == this.newStation)
          if (!checkName) {
            this.addNewStation()
          } else {
            this.setSnackbar({
              icon: 'info',
              color: 'info',
              text: this.$t('AdministrationDiscreteSampleStations.saveExistFailMsg'),
            })
          }
        }
      },
      async addNewStation() {
        console.log(this.currentTenant)
        let payload = {
          TenantId: this.currentTenant.Id,
          StationName: this.newStation,
          Type: this.category || 'Unknown',
        }

        this.loading.submit = true
        try {
          let stationId = await this.postAddDiscreteStation(payload)

          if (this.autoAssign) {
            let response = this.autoAssignDataSources({
              dataSources: [{
                sourceId: stationId,
                sourceType: SOURCE_TYPES.discreteEnvirodata,
              }],
              createNewLocations: true,
              isTestRun: false,
            })

            if (response.IsError) {
              throw 'The discrete station was created, but the location was not. Go to the manage monitoring locations page to try again and to receive a detailed error message.'
            }

            await this.fetchSideMenu()
            await this.fetchMonitoringFeaturesUI()
          }

          await this.fetchDataSources()

          this.clearForm()
          this.setSnackbar({
            icon: 'done',
            color: 'success',
            text: this.$t('AdministrationDiscreteSampleStations.addNewStationSuccessMsg', {
              msg: this.newStation,
            }),
          })
        } catch (err) {
          this.setSnackbar({
            icon: 'error',
            color: 'error',
            text: err,
          })
        }

        this.loading.submit = false
      },
      agreeDeleteStation() {
        let options = {
          data: {
            TenantId: this.currentTenant.Id,
            StationName: this.deleteStation.name,
            Type: this.deleteStation.locationType,
          },
          successCb: () => {
            this.setSnackbar({
              icon: 'done',
              color: 'success',
              text: this.$t('AdministrationDiscreteSampleStations.deleteStationSuccessMsg', {
                msg: this.deleteStation.name,
              }),
            })

            this.confirmDialog = false
            this.fetchDataSources()
          },
          failedCb: (err) => {
            this.setSnackbar({
              icon: 'error',
              color: 'error',
              text: err,
            })
          },
        }
        this.postDeleteDiscreteStation(options)
      },
      clearForm() {
        this.dialog = false
        this.newStation = ''
        this.category = ''
      },
    },
  }
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }

  .backgroundColor {
    background-color: #fafafa;
  }

  .removePadding {
    padding: 0px;
  }
</style>